export const features = {
  home: {
    path: "/",
    icon: "home",
  },
  fan_insights: {
    path: "/reports",
    icon: "chart pie",
    defaultActive: true,
    items: [
      {
        label: "Reports",
        path: "/reports",
      },
      {
        label: "Build Report",
        path: "/reports/new",
      },
      {
        label: "Audiences",
        path: "/audiences",
      },
      {
        label: "Build Audience",
        path: "/audiences/new",
      },
    ],
  },
  fan_rankers: {
    icon: "trophy",
    defaultActive: true,
    path: "/fan-rankers",
  },
  media: {
    icon: "play circle",
    defaultActive: true,
    items: [
      {
        label: "Reports",
        path: "/mediareports",
      },
      {
        label: "Build Report",
        path: "/media/new",
      },
    ],
  },
  custom_projects: {
    icon: "clipboard", // table or industry or file alternate
    hasSelectMenu: true,
    defaultActive: true,
    items: [
      {
        label: "Reports",
        path: `/custom-projects/{projectId}/reports`,
      },
      {
        label: "Build Report",
        path: `/custom-projects/{projectId}/reports/new`,
      },
      {
        label: "Audiences",
        path: `/custom-projects/{projectId}/audiences`,
      },
      {
        label: "Build Audience",
        path: `/custom-projects/{projectId}/audiences/new`,
      },
    ],
  },
  international_fan_insights: {
    icon: "globe",
    defaultActive: true,
    items: [
      {
        label: "Reports",
        path: `/international/reports`,
      },
      {
        label: "Build Report",
        path: `/international/reports/new`,
      },
      {
        label: "Audiences",
        path: `/international/audiences`,
      },
      {
        label: "Build Audience",
        path: `/international/audiences/new`,
      },
    ],
  },
  admin: {
    icon: "key",
    items: [
      {
        label: "Organizations",
        path: "/admin/organizations",
      },
      {
        label: "Media Sessions",
        path: "/admin/media-sessions",
      },
      {
        label: "Brand Override",
        path: "/admin/brand-override",
      },
      {
        label: "Question Map",
        path: "/admin/question-map",
      },
    ],
  },
};

export const admin_media_features = ["Media Sessions", "Brand Override"];
export const admin_user_features = ["Organizations"];

export const api_version = "v1";
export const api_version_latest = "v2";
